import React, { useState } from "react";
import styles from "./Demographics.module.css";
import Age from "./Categories/Age";
import Race from "./Categories/Race";
import Sex from "./Categories/Sex";

const Demographics = ({ data }) => {
  const [hr_race, setHighestRace] = useState({
    name: null,
    pct: 0,
    pop: 0,
  });
  const [hr_age, setHighestAge] = useState({
    name: null,
    pct: 0,
    pop: 0,
  });

  return (
    <div className={styles.Demographics}>
      <div className={styles.DemographicsDesc}>
        <h3>Demographics</h3>
        <p>
          {/* See how homicides compare among sex, age, and race. Numbers
          highlighted in <span className={styles.Highlight}>red</span> show
          which percentage is higher. In 2021 The homicide rate of{" "}
          {hr_race.name} Chicagoans has been{" "}
          {(hr_race.pct / hr_race.pop).toFixed(1)} times higher than the
          population. {hr_age.name} years olds make up the majority of homicides
          at {hr_age.pct.toFixed(1)}% and have a homicide rate{" "}
          {(+hr_age.pct / +hr_age.pop).toFixed(1)} times higher than the
          population. */}
        </p>
      </div>
      <Sex data={data} />
      <Race
        data={data}
        hr_race={hr_race}
        setHighestRace={(val) => setHighestRace(val)}
      />
      <Age
        data={data}
        hr_age={hr_age}
        setHighestAge={(val) => setHighestAge(val)}
      />
      <p className={styles.Notes}>
        Population data source: American Community Survey 2019 1-year estimates
      </p>
    </div>
  );
};

export default Demographics;
